export default {
  webRecruiter: `Recruteur Web`,
  title: `Désabonner`,
  subTitle: ` En se désabonnant, tu ne recevras plus d'information d'AppyHere concernant les emplois proches de toi. Es-tu sûr de vouloir te désabonner? `,
  unSubscribeBtn: 'DÉSABONNER',
  cancel: 'ANNULER',
  unSubscribeError: 'Le désabonnement a échoué. Essayer plus tard.',
};
